export default __webpack_public_path__ + "static/media/Dermacosme.00f1d599.png";